import { useQuery } from "@powersync/react";
import { PMEmptyState, PMSkeleton } from "@/ds/vendor";
import { shortDate } from "@/ui/format";

// Visit forms (core-features 2.2): each submitted form with its values; the
// field-level voice note context (extracted_text) sits under the value.
interface Row { form_id: string; template: string | null; submitted_at: string | null; metric: string | null; value: string | null; extracted_text: string | null; ai_created: number | null; position: number | null }

export function FormsPanel({ visitId }: { visitId: string }) {
  const { data, isLoading } = useQuery<Row>(
    `SELECT f.id AS form_id, t.name AS template, f.submitted_at, mt.name AS metric, me.value, me.extracted_text, me.ai_created,
       (SELECT tm.position FROM mobile_visit_form_template_metrics tm WHERE tm.visit_form_template_id = f.visit_form_template_id AND tm.metric_type_id = me.metric_type_id LIMIT 1) AS position
     FROM mobile_visit_forms f LEFT JOIN visit_form_templates t ON t.id = f.visit_form_template_id
     LEFT JOIN mobile_metrics me ON me.visit_form_id = f.id LEFT JOIN metric_types mt ON mt.id = me.metric_type_id
     WHERE f.field_note_id = ? ORDER BY f.submitted_at, position`, [visitId]);
  if (isLoading && !data.length) return <PMSkeleton shape="rect" height={200} radius={12} />;
  if (!data.length) return <PMEmptyState title="No forms on this visit" description="Structured forms filled on the phone show here with their values." />;
  const forms = new Map<string, Row[]>();
  for (const r of data) forms.set(r.form_id, [...(forms.get(r.form_id) || []), r]);
  return (
    <div className="forms">
      {[...forms.values()].map((rows) => (
        <section className="form-card card" key={rows[0].form_id}>
          <header className="form-head"><strong>{rows[0].template || "Visit form"}</strong><span className="hint">Submitted {shortDate(rows[0].submitted_at)}</span></header>
          <dl className="form-grid">
            {rows.filter((r) => r.metric).map((r, i) => {
              const [label, unit] = splitUnit(r.metric!);
              return (
                <div className="form-field" key={i}>
                  <dt>{label}{r.ai_created ? <span className="ai-tag">AI</span> : null}</dt>
                  <dd>{r.value ?? "—"}{unit && <small> {unit}</small>}</dd>
                  {r.extracted_text && <blockquote className="form-voice">🎙️ “{r.extracted_text}”</blockquote>}
                </div>
              );
            })}
          </dl>
        </section>
      ))}
    </div>
  );
}

function splitUnit(name: string): [string, string | null] {
  const m = name.match(/^(.*?)\s*\(([^)]+)\)$/);
  return m ? [m[1], m[2]] : [name, null];
}
